import {FormModelType} from 'reactjs-use-form'

import {TFunction} from 'i18next'

import {PaymentFormValues} from '@progyny/pages/Budget/Reimbursement/helpers/PaymentFormModel'

export const mapToFormModel = (
  baseModel: FormModelType,
  rawValues: Partial<PaymentFormValues>
): FormModelType => {
  const formModel: FormModelType = {...baseModel}

  for (const key in rawValues) {
    if (formModel[key]) {
      const value = rawValues[key as keyof PaymentFormValues]
      formModel[key] = {
        ...formModel[key],
        value: value ?? '',
      }
    }
  }
  return formModel
}

export const parseLocalFields = (
  raw: string | undefined
): Record<string, string> => {
  if (!raw) return {}
  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, string>
    }
    return {}
  } catch {
    return {}
  }
}

export const setLocalFieldValue = (
  rawLocalFields: string | undefined,
  fieldName: string,
  fieldValue: string
): string => {
  const current = parseLocalFields(rawLocalFields)
  const next = {...current, [fieldName]: fieldValue}
  return JSON.stringify(next)
}

export function returnDescriptionPlaceholder(doctype: string, t: TFunction) {
  switch (doctype) {
    case 'Invoice':
      return t(
        'budget_reimbursement_helpers_util_e_g_follicular_puncture_detailed'
      )
    case 'Proof of payment':
      return t('budget_reimbursement_helpers_util_e_g_screenshot_of_my')
    case 'Medical prescription':
      return t('budget_reimbursement_helpers_util_e_g_medical_prescription_for')
    case 'Partner agreement':
      return t('budget_reimbursement_helpers_util_e_g_for_me_and')
    case 'Treatment plan':
      return t('budget_reimbursement_helpers_util_e_g_treatment_plan_for')
    case 'Treatment results':
      return t('budget_reimbursement_helpers_util_e_g_treatment_results_of')
    case 'Other':
      return t(
        'budget_reimbursement_helpers_util_please_provide_detailed_description'
      )
    default:
      return ''
  }
}
